/* unplugin-vue-components disabled */import { ElTable as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElCheckbox as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { apiAdminRoles } from '@/api/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'roleList',
  props: {
    userId: {
      type: Number,
      default: undefined
    },
    type: {
      type: String,
      default: ''
    }
  },
  emits: ['changeCheck'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const tableData = ref([]);
    const loadingTable = ref(false);
    const getRoleList = () => {
      loadingTable.value = true;
      apiAdminRoles({
        UserId: props.userId
      }).then(res => {
        if (res.code === 0) {
          let arr = [];
          tableData.value = res.data.map(item => {
            if (item.CanAccess) {
              let obj = JSON.parse(JSON.stringify(item));
              obj.CanAccess = obj.CanAccess ? 1 : 0;
              arr.push(obj);
            }
            item.CanAccess = !!item.CanAccess;
            return {
              ...item
            };
          });
          emits('changeCheck', arr);
        }
      }).finally(() => {
        loadingTable.value = false;
      });
    };
    const changeCheck = (e, index, scope) => {
      if (!e) {
        tableData.value[index].CanAuth = 0;
      } else if (scope.RoleId === 1) {
        tableData.value[index].CanAuth = 1;
      }
      changeAuth();
    };
    const changeAuth = () => {
      let allRole = JSON.parse(JSON.stringify(tableData.value));
      let arr = allRole.filter(item => {
        if (item.CanAccess) {
          item.CanAccess = 1;
          return item;
        }
      });
      emits('changeCheck', arr);
    };
    onMounted(() => {
      getRoleList();
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_table = __unplugin_components_2;
      return _openBlock(), _createBlock(_component_el_table, {
        data: _unref(tableData)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "RoleName",
          label: "授权角色组"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
            disabled: __props.type === 'check',
            onChange: $event => changeCheck($event, scope.$index, scope.row),
            modelValue: scope.row.CanAccess,
            "onUpdate:modelValue": $event => scope.row.CanAccess = $event
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.RoleName), 1)]),
            _: 2
          }, 1032, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "授权能力"
        }, {
          default: _withCtx(scope => [_createVNode(USwitch, {
            disabled: __props.type === 'check' || !scope.row.CanAccess,
            onChange: changeAuth,
            modelValue: scope.row.CanAuth,
            "onUpdate:modelValue": $event => scope.row.CanAuth = $event
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]);
    };
  }
});